import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SedsLoadersCoreComponent } from './seds-loaders-core.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [SedsLoadersCoreComponent],
  imports: [CommonModule, MatProgressBarModule, MatProgressSpinnerModule],
  exports: [SedsLoadersCoreComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsLoadersCoreModule {}
